import memoizeOne from "memoize-one";
import { TableColumn } from "react-data-table-component";
import { formatToEst } from "src/common/helper";
import { TooltipCell } from "src/components/Tooltip/TooltipCell";
import { Ticket } from "src/sdk/models/Ticket";

export const TicketingSuperAdminColumns = memoizeOne(
  (
    handleDetailsClick: (ticket: Ticket) => void,
    handleDeleteClick: (ticket: Ticket) => void
  ): TableColumn<Ticket>[] => {
    return [
      {
        id: "ticketId",
        name: <TooltipCell>Ticket ID</TooltipCell>,
        sortable: true,
        cell: row => <TooltipCell>{row.ticketId ?? "-"}</TooltipCell>,
      },
      {
        id: "facility",
        name: <TooltipCell>F/FG Name</TooltipCell>,
        sortable: false,
        cell: row => <TooltipCell>{row.facilityName ? (row.facilityName + " (F)") : (row.facilityGroupName + " (FG)")}</TooltipCell>,
      },   
      {
        id: "status",
        name: <TooltipCell>Status</TooltipCell>,
        sortable: true,
        cell: row => <TooltipCell>{row.status ?? "-"}</TooltipCell>,
      },   
      {
        id: "contact",
        name: <TooltipCell>Contact</TooltipCell>,
        sortable: true,
        cell: row => <TooltipCell>{row.contact ?? "-"}</TooltipCell>,
      },      
      {
        id: "createdBy",
        name: <TooltipCell>Created By</TooltipCell>,
        sortable: true,
        cell: row => <TooltipCell>{row.createdBy ?? "-"}</TooltipCell>,
      },      
      {
        id: "subject",
        name: <TooltipCell>Subject</TooltipCell>,
        sortable: true,
        cell: row => <TooltipCell>{row.subject ?? "-"}</TooltipCell>,
      },
      {
        id: "actions",
        name: <TooltipCell>Actions</TooltipCell>,
        cell: (row: Ticket) => (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              style={{
                backgroundColor: "#95CBB2",
                color: "#FFFFFF",
                border: 0,
                borderRadius: 60,
                width: 120,
                padding: "10px 25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
              }}
              onClick={() => handleDetailsClick(row)}
            >
              <i className="bi bi-list" style={{ marginRight: 6 }} />
              Details
            </button>

          </div>
        ),
        width: "150px",
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
  }
);
